import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { InfoPopoverModule } from '../info-popover/info-popover.module';
import { FieldHintComponent } from './field-hint.component';

@NgModule({
  imports: [CommonModule, InfoPopoverModule, TranslocoRootModule],
  declarations: [FieldHintComponent],
  exports: [FieldHintComponent]
})
export class FieldHintModule {}
